module.exports = __webpack_public_path__ + "img/43.7.Chla.d1473b6e.png";